import $ from 'jquery';

$.addInit(function(context){
	var base = '.i-newsInfoDialog';
	$(base, context).each(function(){
		var component = $(this);
		var close = component.find(base + '-close');

		setTimeout(function() {
			component.addClass('m-active');
		}, 3000);

		close.on('click', function(e) {
			component.removeClass('m-active');
		});
	});
});